import PropTypes from "prop-types"
import React, { Component, Children } from "react"
import Relay from "react-relay"
import { Link } from "react-router"
import classNames from "classnames"
import ResourceImage from "./ResourceImage"
import Icon from "../elements/Icon"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import { injectIntl } from "react-intl"
import settingsMessages from "../../messages/settings"
import CollectionImage from "../elements/CollectionImage";

class ArticleFeature extends Component {
  static propTypes = {
    to: PropTypes.string,
    title: PropTypes.string,
    resource: PropTypes.object.isRequired,
    children: PropTypes.element,
    page: PropTypes.string
  }

  render() {
    const { to, resource, children, className, page, images, intl } = this.props
    const {
      settings: {
        style: { content: styleType }
      }
    } = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    const resourceType = "type" in resource ? resource.type : "collection";

    return (
      <article
        className={classNames("showcase-grid__item", className)}
        data-article-type={resourceType}
      >
        {getStyleTag([
          "data-article-type-flag",
          "data-article-type-icon",
          "showcase-grid__flag__inner",
          "showcase-grid__flag",
          "showcase-grid__image",
          "showcase-grid__icon",
          "showcase-grid__link"
        ])}
        <Link
          to={to || `/item/${resource.id}`}
          className="showcase-grid__link flag-mask"
        >
          {
            "type" in resource ? (
              <ResourceImage
                sizes="(min-width: 512px) 40vw, 100vw"
                className="showcase-grid__image"
                style={getStyles("showcase-grid__image")}
                resource={resource}
              />
            ) : (
              <CollectionImage
                images={images}
                className="showcase-grid__image"
                style={getStyles("showcase-grid__image")}
              />
            )
          }
          {styleType === "type1" ? (
            <div className="flag__bg" style={getStyles("flag__bg")} />
          ) : null}
          <div
            className="flag showcase-grid__flag"
            style={getStyles("showcase-grid__flag")}
          >
            <Icon
              icon="article-type"
              title={resourceType}
              style={getStyles("showcase-grid__icon")}
            />
            <div
              className={classNames("showcase-grid__flag__inner", {
                flag: styleType === "type1"
              })}
              style={getStyles("showcase-grid__flag__inner")}
            >
              <div
                className="flag__content"
                style={getStyles("showcase-grid__flag__content")}
              >
                <h2
                  className={classNames({ mbn: children })}
                  style={getStyles("showcase-grid__flag__h2")}
                >
                  {resource.title}
                </h2>
                {children}
              </div>
            </div>
          </div>
        </Link>
      </article>
    )
  }
}

export default Relay.createContainer(injectIntl(ArticleFeature), {
  fragments: {
    resource: () => Relay.QL`
    fragment on Resource {
        id
        type
        title
        ${ResourceImage.getFragment("resource")}
    }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/ArticleFeature.js